import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import stared from "../../../asset/returnsandstatistics/images/stared.svg";
import { Link, useLocation } from "react-router-dom";
import { UrlPath } from "../../../../config/routeConfig";
import {getCompanyInfo,getBusinessUnits} from "../../../../config/apiConfig";
import { getContactsInfoAction } from "../../../actions/contactsAction";
import { General } from "./General";
import { Addresses } from "./Addresses";
import "../../../investor/investor.css";
import {ContactGeneralAttributes} from "../../../../config/investorConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
export const Companys = () => {
  const locationData = useLocation();
  const dispatch = useDispatch();
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [selectedCompanyInfoButton, setCompanyInfoButton] = useState(locationData.state === null ? 1 : locationData.state.ActiveContactInfoButton);
  const [selectedbusinessUnit,setBusinessUnit]=useState([]);
  const Gstate = useSelector((state) => state) || {};
  const isEditable = Gstate.authorizationData.isEditable;
 
  const [companydetails,SetCompanyDetails]=useState([]);
  useEffect(() => {
    document.title = `Company Details`;
    getCompanyDetails(params.CompanyId);
  }, []);

  useEffect(() => {
    companydetails && setLoading(false);
    if(companydetails?.CompanyInfo?.ContactTypeId===2)
    getBusinessUnitbycompany(params.CompanyId);
  }, [ companydetails]);


  
const getCompanyDetails = async (companyId) => {
  try {

      const response = await sbaAxios({
          url: `${getCompanyInfo}${companyId}`,
          method: 'get',
      });
      const data = response;
      SetCompanyDetails(data);
  } catch (error) {
      console.error("Error fetching entities from API:", error);
  }
};

const getBusinessUnitbycompany= async(companyId)=>
{
  try {

    const response = await sbaAxios({
        url: `${getBusinessUnits}?companyId=${companyId}`,
        method: 'get',
    });
    const data = response;
    setBusinessUnit(data);
} catch (error) {
    console.error("Error fetching entities from API:", error);
}
}
  const addressesData = companydetails?.CompanyAddressDTO?.reduce((result, contact) => {
    const typeName = contact.CompanyAddressTypeName;
    if (!result[typeName]) {
      result[typeName] = [];
    }
    result[typeName].push(contact);
    return result;
  }, {});

  const home = addressesData?.Home;
  const business =  addressesData?.Business[0];
  const statement =  addressesData?.Statement;
  const salutation = companydetails?.CompanyInfo?.Salutation;
  const companyName = companydetails?.CompanyInfo?.CompanyName;
  const companyId= params.CompanyId;
  const contactTypeId =companydetails?.CompanyInfo?.ContactTypeId;
  const isParentCompany = companydetails?.CompanyInfo?.IsParentCompany;
  const parentCompanyId=companydetails?.CompanyInfo?.ParentCompanyId;
  const phone1=companydetails?.CompanyInfo?.Phone1;
  const phone2 = companydetails?.CompanyInfo?.Phone2;
  const fax=companydetails?.CompanyInfo?.Fax;
  const email1 = companydetails?.CompanyInfo?.Email1;
  const email2 = companydetails?.CompanyInfo?.Email2;
  const email3 = companydetails?.CompanyInfo?.Email3;
  const weburl=companydetails?.CompanyInfo?.WebUrl;
  const linkedurl=companydetails?.CompanyInfo?.LinkedInUrl;
  const yearfounded = companydetails?.CompanyInfo?.YearFounded;
  const primarycontact = companydetails?.CompanyInfo?.PrimaryContact;
  const noofemployees = companydetails?.CompanyInfo?.NumberOfEmployees;
  const industry= companydetails?.CompanyInfo?.Industry;
  const annualrevenue=companydetails?.CompanyInfo?.AnnualRevenue;
  const ispublic=companydetails?.CompanyInfo?.IsPublic;
  const notes=companydetails?.CompanyInfo?.CompanyNotes;
  const createdBy = companydetails?.CompanyInfo?.CreatedByName;
  const createdDate = companydetails?.CompanyInfo?.CreatedDate;
  const modifiedByUserName = companydetails?.CompanyInfo?.ModifiedByName;
  const modifiedDate = companydetails?.CompanyInfo?.ModifiedDate;
  const isActive =companydetails?.CompanyInfo?.IsActive;

 

  const [generalData, setGeneralData] = useState({
    salutation: salutation,   
    companyName: companyName,
    companyId: companyId,
    contactTypeId: contactTypeId,
    isParentCompany: isParentCompany,
    parentCompanyId:parentCompanyId,
    phone1: phone1,
    phone2: phone2,
    email1: email1,
    email2: email2,
    email3: email3,
    fax: fax,
    weburl: weburl ,
    linkedurl: linkedurl,
    yearfounded: yearfounded,
    primarycontact: primarycontact,
    noofemployees: noofemployees,
    industry: industry,
    annualrevenue: annualrevenue ,
    ispublic: ispublic,
    notes: notes,
    modifiedByUserName: modifiedByUserName,
    createdBy: createdBy,
    createdDate: createdDate,   
    modifiedDate: modifiedDate,
    isActive: isActive,
  });

  useEffect(() => {
    setGeneralData({
      salutation: salutation,   
      companyName: companyName,
      companyId: companyId,
      contactTypeId: contactTypeId,
      isParentCompany: isParentCompany,
      parentCompanyId:parentCompanyId,
      phone1: phone1,
      phone2: phone2,
      email1: email1,
      email2: email2,
      email3: email3,
      weburl: weburl ,
      fax: fax,
      linkedurl: linkedurl,
      yearfounded: yearfounded,
      primarycontact: primarycontact,
      noofemployees: noofemployees,
      industry: industry,
      annualrevenue: annualrevenue ,
      ispublic: ispublic,
      notes: notes,
      modifiedByUserName: modifiedByUserName,
      createdBy: createdBy,
      createdDate: createdDate,   
      modifiedDate: modifiedDate,
      isActive: isActive,
    });    
  }, [
    salutation,
    companyName,
    companyId,
    contactTypeId,
    isParentCompany,
    parentCompanyId,
    phone1,
    phone2,
    email1,
    email2,
    email3,
    fax,
    weburl,
    linkedurl,
    yearfounded,
    primarycontact,
    noofemployees,
    industry,
    annualrevenue,
    ispublic,
    notes,
    modifiedByUserName,
    createdBy,
    createdDate,
    modifiedDate,
    isActive
  ]);

  const [addressData, setAddressData] = useState({
    homeAddressId: home?.CompanyAddressId,
    homeAddressTypeId: home?.CompanyAddressTypeId,
    home: home?.CompanyAddressTypeName,
    homeNote: home?.Note,
    homeProvince: home?.AddressProvince,
    homeCity: home?.AddressCity,
    homeCountry: home?.AddressCountry,
    homeCountryId: home?.AddressCountryId,
    homeState: home?.AddressState,
    homeAddressStreet1: home?.AddressStreet,
    homeAddressStreet2: home?.AddressStreet2,
    homeZip: home?.AddressZip,
    businessAddressId: business?.CompanyAddressId,
    businessAddressTypeId: business?.CompanyAddressTypeId,
    business: business?.CompanyAddressTypeName,
    businessNote: business?.Note,
    businessProvince: business?.AddressProvince,
    businessCity: business?.AddressCity,
    businessCountry: business?.AddressCountry,
    businessCountryId: business?.AddressCountryId,
    businessState: business?.AddressState,
    businessAddressStreet1: business?.AddressStreet,
    businessAddressStreet2: business?.AddressStreet2,
    businessZip: business?.AddressZip,
    statementAddressId: statement?.CompanyAddressId,
    statementAddressTypeId: statement?.CompanyAddressTypeId,
    statement: statement?.CompanyAddressTypeName,
    statementNote: statement?.Note,
    statementAddressProvince: statement?.AddressProvince,
    statementAddressCity: statement?.AddressCity,
   statementAddressCountry: statement?.AddressCountry,
   statementAddressCountryId: statement?.AddressCountryId,
    statementAddressState: statement?.AddressState,
    statementAddressStreet1: statement?.AddressStreet,
    statementAddressStreet2: statement?.AddressStreet2,
    statementAddressZip: statement?.AddressZip,
  });

  useEffect(() => {
    setAddressData({
      homeAddressId: home?.CompanyAddressId,
      homeAddressTypeId: home?.CompanyAddressTypeId,
      home: home?.CompanyAddressTypeName,
      homeNote: home?.Note,
      homeProvince: home?.AddressProvince,
      homeCity: home?.AddressCity,
      homeCountry: home?.AddressCountry,
      homeCountryId: home?.AddressCountryId,
      homeState: home?.AddressState,
      homeAddressStreet1: home?.AddressStreet,
      homeAddressStreet2: home?.AddressStreet2,
      homeZip: home?.AddressZip,
      businessAddressId: business?.CompanyAddressId,
      businessAddressTypeId: business?.CompanyAddressTypeId,
      business: business?.CompanyAddressTypeName,
      businessNote: business?.Note,
      businessProvince: business?.AddressProvince,
      businessCity: business?.AddressCity,
        businessCountry: business?.AddressCountry,
        businessCountryId: business?.AddressCountryId,
      businessState: business?.AddressState,
      businessAddressStreet1: business?.AddressStreet,
      businessAddressStreet2: business?.AddressStreet2,
      businessZip: business?.AddressZip,
      statementAddressId: statement?.CompanyAddressId,
      statementAddressTypeId: statement?.CompanyAddressTypeId,
      statement: statement?.CompanyAddressTypeName,
      statementNote: statement?.Note,
      statementAddressProvince: statement?.AddressProvince,
      statementAddressCity: statement?.AddressCity,
      statementAddressCountry: statement?.AddressCountry,
      statementAddressCountryId: statement?.AddressCountryId,
      statementAddressState: statement?.AddressState,
      statementAddressStreet1: statement?.AddressStreet,
      statementAddressStreet2: statement?.AddressStreet2,
      statementAddressZip: statement?.AddressZip,
    });
  }, [
    home,
    business,
    statement,  
  ]);

  const buttonNames = [
    { buttonIds: 1, name: "General" },
    { buttonIds: 2, name: "Addresses" },
  ];

  const CompanyInfoButtons = buttonNames.map((button, index) => (
    <button
      key={index}
      id={`button-${button.buttonIds}`}
      className={`non-gappable-button ${selectedCompanyInfoButton === button.buttonIds
        ? "selected-non-gappable-button"
        : ""
        }`}
      onClick={() => companyInfoButtonClick(button.buttonIds)}
    >
      {button.name}
    </button>
  ));

  const companyInfoButtonClick = (buttonId) => {
    setCompanyInfoButton(buttonId);
  };

  let componentToRender;

  switch (selectedCompanyInfoButton) {
    case 1:
      componentToRender = <General companyData={generalData} businessData={selectedbusinessUnit}/>;
      break;
    case 2:
      componentToRender = <Addresses companyData={addressData}/>;
      break;   
    default:
      componentToRender = null;
  }

  return (
    <>
      {loading ? (
        <>
          <LoadingScreen />
        </>
      ) : (
        <>
          <div id="contacts" className="mainContentData">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center">
                <div className="button-container">{CompanyInfoButtons}</div>
                <div className="d-flex justify-content-end align-items-center gap-4">
                  <Link
                    title="Click to edit Details"
                    to={
                      isEditable &&
                      `${UrlPath.CompanyDetailsEdit}${params.CompanyId}?ContactTypeId=${contactTypeId}`
                    }
                    state={{
                      selectedCompanyInfoButton: selectedCompanyInfoButton, companyData: generalData, AddressData: addressData
                    }}
                    className={isEditable ? "" : "disabledControl"}
                  >
                    <i className="fa-solid fa-pencil edit_icon"></i>
                  </Link>
                  {/* <a href="#">
                    <img src={stared} alt="" />
                  </a> */}
                </div>
              </div>
              <div className="content-container">{componentToRender}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
